import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';
import { env } from './env';

/** Ported unchanged from the Angular main.ts. */
export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.userPoolId,
        userPoolClientId: env.userPoolClientId,
        identityPoolId: env.identityPoolId,
        loginWith: { email: true },
        signUpVerificationMethod: 'code',
        userAttributes: { email: { required: true } },
        allowGuestAccess: false,
        passwordFormat: {
          minLength: 12,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });

  // Technically the default, but we choose to be explicit.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
}
